// extracted by mini-css-extract-plugin
export default {"container":"TagContainer_container__RK+w-"};